import { Schema } from 'normalizr';
import { baseSchema } from '../../../types/schema';
import { keys } from './keys';

/**
 * Units Entity Schema
 *
 * Normalizr schema for Units entities.
 * Uses templateSchema (baseSchema) for enhanced normalization support.
 */
const unitSchema = baseSchema(keys.state);

export { unitSchema };

// Type assertion for better TypeScript support
export const typedUnitSchema: Schema = unitSchema;